import styled from 'styled-components';

interface IProps {
  width?: string;
}

export const TitleLine = styled.div<IProps>`
  width: ${p => p.width};
  height: 0.25rem;
  background-image: linear-gradient(-180deg, #379bf4 0%, #1c56bf 100%);
  box-shadow: 0 0 10px 0 rgba(16, 122, 213, 0.5);
  border-radius: 5px;
`;

TitleLine.defaultProps = {
  width: '100%',
};
